
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image, Link } from 'contentbricks'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Kürzlich titelte der «Tages-Anzeiger» <Link href='https://interaktiv.tagesanzeiger.ch/2020/gastro-riesen-zuerich/' mdxType="Link">«100 Restaurants, 9 Firmen»</Link> und zeigte,
  wie die Zürcher Gastroszene von wenigen Beizern beeinflusst wird. Ganz so
  eindeutige Zahlen wie in der Zwinglistadt gibt es in Bern nicht: In der
  Bundesstadt sind es 42 Restaurants mit unterschiedlichen Konzepten, die in den
  Händen von neun Wirten sind.
    </p>
    <p>
  Insgesamt existieren in der Stadt Bern 728 Restaurants mit
  Alkoholausschankbewilligung. Die meisten Beizer führen ein einzelnes Lokal,
  zahlreiche führen zwei. In unserer Recherche sind alle Unternehmen
  berücksichtigt, die drei und mehr öffentliche Restaurants mit klarem Konzept
  in ihrem Portfolio haben. Ausgeklammert sind Kantinen der SV Group oder
  Selbstbedienungsrestaurants der Supermärkte Migros und Coop. Die Gastrogrössen
  konzentrieren sich auf die Berner Innenstadt, primär rund um den
  Kornhausplatz.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;